import React, { useContext } from "react";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

import AppFlow from "../src/navigation/AppFlow";
import { appContext } from "./context/ContextProvider";
import { GRAPHQL_URL } from "./config/apiConfig";

function ApolloAppProvider(props) {
  const { token, setToken } = useContext(appContext);
  // /https://api.supergitsa.com/
  // https://api.supergitsa.com

  // const url = 'https://api.supergitsa.com/query'
  // const url = "https://api.supergitsa.com/query";
  const url = GRAPHQL_URL;
  //const url = "https://stage.api.connect.supergitsa.com/query";
  // const url = 'https://mq85j3ll-8000.inc1.devtunnels.ms/query'
  const httpLink = createHttpLink({
    uri: url,
  });

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        if (err.message.toLowerCase().includes("please login to continue")) {
          console.log(":: Token expired/Session invalid!");
          localStorage.clear();
          setToken(null);
          break;
        }
      }
    }
    if (
      networkError &&
      (networkError.statusCode === 401 || networkError.statusCode === 403)
    ) {
      // Handle the forbidden (403) and unauthorized (401) response here
      console.log(":: Forbidden/Unauthorized request!");
      localStorage.clear();
      setToken(null);
      // You can call a function or perform any custom logic you need
    }
  });

  const client = new ApolloClient({
    link: errorLink.concat(authLink).concat(httpLink),
    cache: new InMemoryCache(),
  });

  return (
    <ApolloProvider client={client}>
      <AppFlow />
    </ApolloProvider>
  );
}

export default ApolloAppProvider;
